import { render, staticRenderFns } from "./groups-list.vue?vue&type=template&id=cf051fae&lang=pug&"
import script from "./groups-list.vue?vue&type=script&lang=js&"
export * from "./groups-list.vue?vue&type=script&lang=js&"
import style0 from "./groups-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports